<template>
  <v-btn @click="addArticleToLabels"
    class="addToLabelsBtn"
  />
</template>

<script>
import {mapActions} from 'vuex'
export default {
  props: ['article'],
  name: "addToLabels",

  data() {
    return {

    }
  },

  methods: {
    ...mapActions({
      addProductToLabels: 'addProductToLabels'
    }),

    addArticleToLabels() {
      this.addProductToLabels(this.article)
    }
  }
}
</script>

<style scoped>

</style>
